import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import { Button, ButtonGroup, Table } from "reactstrap";
import moment from "moment";

import { GetLanguageString } from "../../helper/Components";
import { GetCustomStyles, GetSelectedLanguage } from "../../helper/Method";
import { addMember } from "../ApiMember";
import { convertUTCToLocalTime } from "../../../constants/const";
import AddResponsibilityByUnit from "./AddResponsibilityByUnit";
import DeleteResponsibility from "./DeleteResponsibility";
import EditMemberResponsibility from "./EditMemberResponsibility";

const MemberResponsibilityList = ({
  tab8,
  memberId,
  unitId,
  unitName,
  addNewRafiq,
  setUpdatedDetails,
}) => {
  const [responsibilityStateChange, setResponsibilityStateChange] =
    useState(false);
  const [loading1, setLoading1] = useState(false);
  const [units, setUnits] = useState([]);
  const [unitNames, setUnitNames] = useState([]);
  const [deleteResponsibility, setDeleteResponsibility] = useState({});
  const [editResponsibility, setEditResponsibility] = useState({});
  const [addResponsibilityModal, setAddResponsibilityModal] = useState(false);
  const [editResponsibilityModal, setEditResponsibilityModal] = useState(false);
  const [
    endMemberResponsibilityDateModal,
    setEndMemberResponsibilityDateModal,
  ] = useState(false);

  useEffect(() => {
    if (tab8 === "active") {
      addMember()
        .getMemberResponsibilityList(memberId)
        .then((res) => {
          let tempNames = [];
          res.data.forEach((element) => {
            tempNames.push({
              names: element.unit.label.split("،"),
            });
          });
          setUnitNames(tempNames);
          setUnits(res.data);
        })
        .catch((err) => console.log(err));
    }
  }, [memberId, unitId, unitName, responsibilityStateChange, tab8]);
  return (
    <>
      {editResponsibilityModal ? (
        <EditMemberResponsibility
          addNewRafiq={addNewRafiq}
          editResponsibility={editResponsibility}
          loading1={loading1}
          unitId={editResponsibility.unit.value}
          memberId={memberId}
          setUpdatedDetails={setUpdatedDetails}
          editResponsibilityModal={editResponsibilityModal}
          setEditResponsibilityModal={setEditResponsibilityModal}
          setResponsibilityStateChange={setResponsibilityStateChange}
        />
      ) : null}
      {addResponsibilityModal ? (
        <AddResponsibilityByUnit
          addNewRafiq={addNewRafiq}
          loading1={loading1}
          unitId={unitId}
          memberId={memberId}
          setUpdatedDetails={setUpdatedDetails}
          addResponsibilityModal={addResponsibilityModal}
          setAddResponsibilityModal={setAddResponsibilityModal}
          setResponsibilityStateChange={setResponsibilityStateChange}
        />
      ) : null}
      {endMemberResponsibilityDateModal ? (
        <DeleteResponsibility
          setResponsibilityStateChange={setResponsibilityStateChange}
          setEndMemberResponsibilityDateModal={
            setEndMemberResponsibilityDateModal
          }
          deleteResponsibility={deleteResponsibility}
          setUpdatedDetails={setUpdatedDetails}
        />
      ) : null}
      <div className="panel-body">
        <div className="panel panel-primary">
          <div className="panel-heading">
            <Button
              color="dark"
              size="xs"
              className={GetCustomStyles().btn_style}
              onClick={() => {
                setLoading1(true);
                setAddResponsibilityModal(true);
              }}
            >
              {<GetLanguageString props="settings_add_responsibility" />}
            </Button>
            {
              <GetLanguageString props="member_select_unit_and_responsibilities" />
            }
          </div>
          <div className="panel-body">
            {units?.length !== 0 ? (
              <Table>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>
                      {
                        <GetLanguageString props="member_member_detail_common_unit_name" />
                      }
                    </th>
                    <th>
                      {
                        <GetLanguageString props="member_member_detail_common_responsibility" />
                      }
                    </th>
                    <th>
                      {
                        <GetLanguageString props="member_member_detail_common_responsibility_date" />
                      }
                    </th>
                    <th>
                      {<GetLanguageString props="member_reference_note" />}
                    </th>
                    <th className="text-right">
                      {<GetLanguageString props="common_action" />}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {units?.map((record, index) => {
                    return (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td className="ur">
                          <ol className="breadcrumb">
                            {unitNames[index]?.names?.map((item, index) => {
                              return (
                                <li
                                  className={
                                    GetSelectedLanguage() === "ur"
                                      ? "breadcrumb-item-ur"
                                      : "breadcrumb-item"
                                  }
                                  key={index}
                                >
                                  {item}
                                </li>
                              );
                            })}
                          </ol>
                        </td>
                        <td className="ur">
                          {record.displayName !== "" ? (
                            <span>
                              ({record.displayName}) {record.responsibilityName}{" "}
                            </span>
                          ) : (
                            record.responsibilityName
                          )}
                        </td>
                        <td>
                          {record.responsibilityDate
                            ? moment(
                                convertUTCToLocalTime(record.responsibilityDate)
                              ).format("DD/MM/yyyy")
                            : "-"}
                        </td>
                        <td>{record?.referenceNote}</td>
                        <td className="text-right">
                          <ButtonGroup>
                            <Button
                              color="white"
                              size="sm"
                              onClick={() => {
                                setEditResponsibility(record);
                                setEditResponsibilityModal(true);
                              }}
                            >
                              {<GetLanguageString props="common_edit" />}
                            </Button>
                            <Button
                              color="white"
                              size="sm"
                              onClick={() => {
                                setDeleteResponsibility(record);
                                setEndMemberResponsibilityDateModal(true);
                              }}
                            >
                              {<GetLanguageString props="common_delete" />}
                            </Button>
                          </ButtonGroup>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            ) : (
              <>
                <h4 className="text-error text-center">
                  {
                    <GetLanguageString props="common_no_result_responsibilities" />
                  }
                </h4>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default withRouter(MemberResponsibilityList);
